import { type FC, lazy } from "react"
import styled from "styled-components"

import Button from "~/components/Button"
import routes from "~/utilities/routes"
import { componentBackgroundColor, componentBorderColor, lightTextColor } from "~/utilities/styles"

const LockedFeatureImage = lazy(() => import("./LockedFeatureImage"))

const LockedFeature: FC<{ className?: string }> = ({ className }) => (
	<Container className={className}>
		<LockedFeatureImage className="text-primary w-56 max-w-full" />
		<Title>This feature is locked</Title>
		<Text>In order to use this feature you need to upgrade your plan.</Text>
		<Button variant="primary" onClick={routes.settings.billing.plans()}>
			Browse plans
		</Button>
	</Container>
)

const Container = styled.div`
	background-color: ${componentBackgroundColor};
	border: 1px solid ${componentBorderColor};
	border-radius: 24px;
	padding: clamp(24px, 4vw, 40px);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
`

const Title = styled.h2`
	font-weight: 600;
	font-size: 20px;
`

const Text = styled.p`
	color: ${lightTextColor};
	text-align: center;
	max-width: 500px;
`

export default LockedFeature
